/* AM Luxury — product page: gallery thumbnails + variant selection.
   Without JS the page still renders and adds the first available variant. */
(function () {
  'use strict';

  function parseJSON(el) {
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }

  function init(scope) {
    var root = (scope || document).querySelector('[data-lux-product]');
    if (!root || root.dataset.luxBound === '1') return;
    root.dataset.luxBound = '1';

    var main = root.querySelector('[data-lux-main]');
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-lux-thumb]'));
    var variants = parseJSON(root.querySelector('[data-lux-variants]')) || [];
    var labels = parseJSON(root.querySelector('[data-lux-labels]')) || {};
    var idInput = root.querySelector('[data-lux-variant-id]');
    var priceEl = root.querySelector('[data-lux-price]');
    var addBtn = root.querySelector('[data-lux-add]');
    var optionGroups = Array.prototype.slice.call(root.querySelectorAll('[data-lux-option]'));

    /* ---------- gallery ---------- */
    function showImage(src, mediaId) {
      if (!main || !src) return;
      var img = main.querySelector('img');
      if (img) {
        img.removeAttribute('srcset');
        img.setAttribute('src', src);
      } else {
        main.innerHTML = '<img src="' + src + '" alt="">';
      }
      thumbs.forEach(function (t) {
        t.classList.toggle('lux-active', mediaId != null && String(t.dataset.luxMediaId) === String(mediaId));
      });
    }

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        thumbs.forEach(function (t) { t.classList.remove('lux-active'); });
        thumb.classList.add('lux-active');
        var img = main && main.querySelector('img');
        if (img && thumb.dataset.luxSrc) {
          img.removeAttribute('srcset');
          img.setAttribute('src', thumb.dataset.luxSrc);
        }
      });
    });

    /* ---------- wishlist (shares storage with the product cards) ---------- */
    var wish = root.querySelector('[data-lux-wish]');
    if (wish) {
      var WKEY = 'lux:wishlist';
      var handle = wish.getAttribute('data-lux-wish');
      var read = function () {
        try { return JSON.parse(localStorage.getItem(WKEY)) || []; } catch (e) { return []; }
      };
      if (read().indexOf(handle) !== -1) {
        wish.classList.add('is-on');
        wish.setAttribute('aria-pressed', 'true');
        wish.textContent = '♥';
      }
      wish.addEventListener('click', function () {
        var list = read();
        var at = list.indexOf(handle);
        if (at === -1) {
          list.push(handle);
          wish.classList.add('is-on');
          wish.setAttribute('aria-pressed', 'true');
          wish.textContent = '♥';
        } else {
          list.splice(at, 1);
          wish.classList.remove('is-on');
          wish.setAttribute('aria-pressed', 'false');
          wish.textContent = '♡';
        }
        try { localStorage.setItem(WKEY, JSON.stringify(list)); } catch (e) { /* private mode */ }
      });
    }

    /* ---------- variants ---------- */
    if (!variants.length || !optionGroups.length) return;

    function selectedOptions() {
      return optionGroups.map(function (group) {
        var active = group.querySelector('.lux-active');
        return active ? active.dataset.luxValue : null;
      });
    }

    function findVariant(selection) {
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i];
        var match = true;
        for (var j = 0; j < selection.length; j++) {
          if (selection[j] !== v.options[j]) { match = false; break; }
        }
        if (match) return v;
      }
      return null;
    }

    function update() {
      var selection = selectedOptions();
      var variant = findVariant(selection);

      /* the value name printed next to the option label */
      optionGroups.forEach(function (group) {
        var out = group.querySelector('[data-lux-option-value]');
        var active = group.querySelector('.lux-active');
        if (out && active) out.textContent = active.dataset.luxValue;
      });

      if (!variant) {
        if (addBtn) {
          addBtn.disabled = true;
          addBtn.textContent = labels.unavailable || 'Unavailable';
        }
        return;
      }

      if (idInput) idInput.value = variant.id;

      if (priceEl) {
        priceEl.innerHTML = (variant.compare_at ? '<s>' + variant.compare_at + '</s>' : '') + variant.price;
      }

      if (addBtn) {
        addBtn.disabled = !variant.available;
        if (variant.available) {
          addBtn.innerHTML = (labels.add || 'Add to bag') + ' — ' + variant.price;
        } else {
          addBtn.textContent = labels.soldOut || 'Sold out';
        }
      }

      if (variant.image) showImage(variant.image, variant.media_id);

      /* Nothing else in this theme announced a variant switch, so anything
         downstream of the picker (the low-stock counter) had no way to know.
         The payload carries the inventory fields the section now emits. */
      try {
        document.dispatchEvent(new CustomEvent('variant:change', {
          detail: { variant: variant }
        }));
      } catch (e) { /* no CustomEvent: the counter just keeps its load-time value */ }

      try {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      } catch (e) { /* older browsers: skip the URL sync */ }
    }

    optionGroups.forEach(function (group) {
      group.addEventListener('click', function (event) {
        var btn = event.target.closest('.lux-chip, .lux-swatch-lg');
        if (!btn || !group.contains(btn)) return;
        group.querySelectorAll('.lux-chip, .lux-swatch-lg').forEach(function (b) {
          b.classList.remove('lux-active');
        });
        btn.classList.add('lux-active');
        update();
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();

/* ------------------------------------------------------------------
   Gift note
   The textarea stays disabled until the shopper opts in, so an empty
   properties[Gift note] is never posted with the line item.

   The note is also mirrored onto a CART-LEVEL attribute. Engraving and
   locket products post their own /cart/add.js and never submit
   #lux-product-form, so the line-item property alone is silently
   dropped for exactly the products most likely to be gifts. The
   attribute is written from the shopper's own edits only — never on
   load — so browsing to another product cannot wipe a note already set.
   ------------------------------------------------------------------ */
(function () {
  var DEBOUNCE_MS = 400;
  var ATTR = 'Gift note';
  var UPDATE_URL =
    (window.routes && window.routes.cart_update_url ? window.routes.cart_update_url : '/cart/update') + '.js';
  var CART_URL =
    (window.routes && window.routes.cart_url ? window.routes.cart_url : '/cart') + '.js';

  /* Writes are chained so a slow request can never land on top of a
     newer value, and deduped so an idle blur costs nothing. */
  var chain = Promise.resolve();
  var lastSent = null;

  function pushAttribute(value) {
    if (value === lastSent) return;
    lastSent = value;
    var attributes = {};
    attributes[ATTR] = value;
    chain = chain
      .then(function () {
        return fetch(UPDATE_URL, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ attributes: attributes })
        });
      })
      .then(function (resp) {
        /* fetch only rejects on network failure — a 4xx/5xx still resolves.
           Counting that as success would leave lastSent describing a value
           the cart never stored, and every identical retry would then be
           deduped away, so the note would silently never land. */
        if (!resp.ok) throw new Error('cart update ' + resp.status);
      })
      .catch(function () {
        /* A dropped write must not wedge the chain or break the page.
           Forgetting the value lets the next edit retry it. */
        lastSent = null;
      });
  }

  function wireGift(scope) {
    var root = scope || document;
    root.querySelectorAll('[data-lux-gift]').forEach(function (gift) {
      if (gift.dataset.luxGiftReady === '1') return;
      gift.dataset.luxGiftReady = '1';

      var toggle = gift.querySelector('[data-lux-gift-toggle]');
      var panel = gift.querySelector('[data-lux-gift-panel]');
      var note = gift.querySelector('[data-lux-gift-note]');
      if (!toggle || !panel || !note) return;

      var timer = null;

      function cancelPending() {
        if (timer) {
          clearTimeout(timer);
          timer = null;
        }
      }

      /* Always resolves against the live control state, so an in-flight
         debounce that is cancelled can never resurrect a cleared note. */
      function sync() {
        cancelPending();
        pushAttribute(toggle.checked ? note.value.trim() : '');
      }

      toggle.addEventListener('change', function () {
        var on = toggle.checked;
        panel.hidden = !on;
        note.disabled = !on;
        gift.classList.toggle('is-open', on);
        if (on) {
          /* Opening the panel is not a note change — nothing is typed
             yet, so this must not clear an attribute already set. */
          try { note.focus({ preventScroll: true }); } catch (e) { note.focus(); }
        } else {
          note.value = '';
          sync();
        }
      });

      note.addEventListener('input', function () {
        cancelPending();
        timer = setTimeout(sync, DEBOUNCE_MS);
      });

      note.addEventListener('blur', sync);
    });
  }

  /* The attribute outlives the page. A note set earlier in the session stays
     on the cart while a freshly rendered toggle shows unticked, so the shopper
     can neither see nor clear a note that is still attached to their order.
     Reading the live cart on load keeps the control honest about that. */
  function hydrate() {
    fetch(CART_URL, { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var value = cart && cart.attributes ? cart.attributes[ATTR] || '' : '';
        if (!value) return;
        /* Already on the cart — record it so the first blur is not a write. */
        lastSent = value;
        document.querySelectorAll('[data-lux-gift]').forEach(function (gift) {
          var toggle = gift.querySelector('[data-lux-gift-toggle]');
          var panel = gift.querySelector('[data-lux-gift-panel]');
          var note = gift.querySelector('[data-lux-gift-note]');
          if (!toggle || !panel || !note) return;
          /* Never overwrite a shopper who got there before the response. */
          if (toggle.checked || note.value) return;
          toggle.checked = true;
          panel.hidden = false;
          note.disabled = false;
          gift.classList.add('is-open');
          note.value = value;
          /* Opened programmatically, so no focus() here — it would pull the
             viewport down to the note on every page load. */
        });
      })
      .catch(function () { /* offline or no cart: leave the control closed */ });
  }

  function start() {
    wireGift();
    hydrate();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
  /* Re-wire on section reload, but do not re-hydrate: the shopper may be
     mid-edit in the theme editor. */
  document.addEventListener('shopify:section:load', function (e) { wireGift(e.target); });
})();

/* ------------------------------------------------------------------
   Sticky buy bar
   Appears once the buy area scrolls away. Its button is a proxy for
   whichever control the product actually uses, so there is still only
   one add-to-cart path. Hidden whenever a builder overlay is open.
   ------------------------------------------------------------------ */
(function () {
  var OVERLAYS = '.amx-overlay, .amx-fullscreen, .lb-host .lb-overlay';

  function overlayOpen() {
    var nodes = document.querySelectorAll(OVERLAYS);
    for (var i = 0; i < nodes.length; i++) {
      var cs = getComputedStyle(nodes[i]);
      if (cs.display !== 'none' && cs.visibility !== 'hidden') return true;
    }
    return false;
  }

  function primaryControl(kind) {
    if (kind === 'engraving') return document.querySelector('.amx-trigger');
    if (kind === 'locket') return document.querySelector('.lb-trigger');
    return document.querySelector('[data-lux-add]');
  }

  /* One evaluation, driven by scroll/resize. Elements are re-resolved each
     time so a section re-render can never leave a stale reference behind. */
  function evaluate() {
    var bar = document.querySelector('[data-lux-sticky]');
    var anchor = document.querySelector('[data-lux-sticky-anchor]');
    if (!bar || !anchor) return;

    var show = anchor.getBoundingClientRect().bottom < 0 && !overlayOpen();
    bar.classList.toggle('is-on', show);
    document.documentElement.classList.toggle('lux-has-sticky', show);
  }

  var ticking = false;
  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () { ticking = false; evaluate(); });
  }

  function wireCta() {
    var bar = document.querySelector('[data-lux-sticky]');
    if (!bar || bar.dataset.luxReady === '1') return;
    bar.dataset.luxReady = '1';
    var kind = bar.getAttribute('data-lux-sticky-kind') || 'add';
    var cta = bar.querySelector('[data-lux-sticky-cta]');
    if (!cta) return;
    cta.addEventListener('click', function () {
      var target = primaryControl(kind);
      if (!target) return;
      // let this click finish dispatching before a builder takes focus
      setTimeout(function () { target.click(); }, 0);
    });
  }

  function start() {
    wireCta();
    evaluate();
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll, { passive: true });
  // a builder can open or close without any scrolling
  document.addEventListener('click', function () { setTimeout(evaluate, 140); }, true);
  document.addEventListener('keyup', function (e) { if (e.key === 'Escape') setTimeout(evaluate, 140); });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
  document.addEventListener('shopify:section:load', start);
})();
